(function () {
  'use strict';

  function updateLastVisibleItem(items) {
    var lastVisible = null;

    items.forEach(function (item) {
      item.classList.remove('is-last-visible');
      if (!item.classList.contains('is-hidden')) {
        lastVisible = item;
      }
    });

    if (lastVisible) {
      lastVisible.classList.add('is-last-visible');
    }
  }

  function initFilters(section) {
    var filters = section.querySelectorAll('[data-faq-sauna-filter]');
    var items = section.querySelectorAll('[data-faq-sauna-item]');
    var empty = section.querySelector('[data-faq-sauna-empty]');
    if (!filters.length || !items.length) return;

    function setActiveFilter(filterBtn) {
      filters.forEach(function (btn) {
        var isActive = btn === filterBtn;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function applyFilter(categoryHandle) {
      var visibleCount = 0;

      items.forEach(function (item) {
        var itemCategory = item.getAttribute('data-faq-category') || '';
        var show =
          !categoryHandle ||
          !itemCategory ||
          itemCategory === categoryHandle;

        item.classList.toggle('is-hidden', !show);

        if (!show && item.classList.contains('is-open')) {
          item.classList.remove('is-open');
          var trigger = item.querySelector('[data-faq-sauna-trigger]');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        }

        if (show) visibleCount += 1;
      });

      if (empty) {
        empty.classList.toggle('is-hidden', visibleCount > 0);
      }

      updateLastVisibleItem(items);
    }

    filters.forEach(function (btn, index) {
      btn.addEventListener('click', function () {
        setActiveFilter(btn);
        applyFilter(btn.getAttribute('data-faq-sauna-filter') || '');
      });

      if (index === 0) {
        setActiveFilter(btn);
        applyFilter(btn.getAttribute('data-faq-sauna-filter') || '');
      }
    });
  }

  function initAccordion(section) {
    section.querySelectorAll('[data-faq-sauna-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('[data-faq-sauna-item]');
        if (!item || item.classList.contains('is-hidden')) return;

        var isOpen = item.classList.contains('is-open');

        section.querySelectorAll('[data-faq-sauna-item].is-open').forEach(function (openItem) {
          if (openItem !== item) {
            openItem.classList.remove('is-open');
            var btn = openItem.querySelector('[data-faq-sauna-trigger]');
            if (btn) btn.setAttribute('aria-expanded', 'false');
          }
        });

        item.classList.toggle('is-open', !isOpen);
        trigger.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
      });
    });
  }

  function initSection(section) {
    if (!section || section.getAttribute('data-faq-sauna-initialized') === 'true') return;
    section.setAttribute('data-faq-sauna-initialized', 'true');
    initFilters(section);
    initAccordion(section);

    var items = section.querySelectorAll('[data-faq-sauna-item]');
    if (items.length) {
      updateLastVisibleItem(items);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="faq-sauna"]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section =
      e.target.querySelector('[data-section-type="faq-sauna"]') || e.target;
    if (section && section.matches && section.matches('[data-section-type="faq-sauna"]')) {
      section.removeAttribute('data-faq-sauna-initialized');
      initSection(section);
    }
  });
})();
